module.exports = __webpack_public_path__ + "fonts/HSESans-Italic.9672fae.otf";